import {
  RatingScreenMode,
  RatingTicketPhase
} from '../../types/Rating/RatingTypes';

export const isScreensaverPhaseAllowed = (
  screenMode: RatingScreenMode | undefined,
  phases: RatingTicketPhase[] | undefined,
  ticketPhase?: RatingTicketPhase | null
): boolean => {
  if (!phases?.length) {
    return true;
  }
  switch (screenMode) {
    case 'SCREENSAVER':
    case 'STANDBY':
      return true;
    case 'AWAITING_RATING':
      return phases.includes(ticketPhase ?? 'COMPLETION');
    case 'IN_SERVICE':
      return ticketPhase != null && phases.includes(ticketPhase);
    default:
      return false;
  }
};
